import { EntityModel } from '@/interfaces'
import {
  ALL_FILES_QUERY,
  CREATE_FILE_MUTATION,
  DELETE_FILE_MUTATION,
  FORCE_DELETE_FILE_MUTATION,
  SINGLE_FILE_QUERY,
  UPDATE_FILE_MUTATION,
} from './graphql'

const mediaFileModel: EntityModel = {
  name: 'file',
  namePlural: 'files',
  uniqueName: 'mediaFile',
  uniqueNamePlural: 'mediaFiles',
  path: 'media/file',
  baseUrl: '/media/files',
  translationPrefix: 'entities:mediaFile.',
  getDisplayName: (values: any) => {
    return values.title
  },
  gql: {
    getAll: ALL_FILES_QUERY,
    getSingle: SINGLE_FILE_QUERY,
    create: CREATE_FILE_MUTATION,
    update: UPDATE_FILE_MUTATION,
    delete: DELETE_FILE_MUTATION,
    forceDelete: FORCE_DELETE_FILE_MUTATION,
  },
  attributes: {
    assetId: {
      name: 'assetId',
      label: 'entities:mediaFile.attributes.assetId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    publicId: {
      name: 'publicId',
      label: 'entities:mediaFile.attributes.publicId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    url: {
      name: 'url',
      label: 'entities:mediaFile.attributes.url.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    resourceType: {
      name: 'resourceType',
      label: 'entities:mediaFile.attributes.resourceType.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    format: {
      name: 'format',
      label: 'entities:mediaFile.attributes.format.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    width: {
      name: 'width',
      label: 'entities:mediaFile.attributes.width.label',
      type: 'value',
      dataType: 'number',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    height: {
      name: 'height',
      label: 'entities:mediaFile.attributes.height.label',
      type: 'value',
      dataType: 'number',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    caption: {
      name: 'caption',
      label: 'entities:mediaFile.attributes.caption.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    title: {
      name: 'title',
      label: 'entities:mediaFile.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    description: {
      name: 'description',
      label: 'entities:mediaFile.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default mediaFileModel
